import { Box, Skeleton } from '@mui/material';

export const LoadMore = () => {
  return (
    <Box sx={{ backgroundColor: 'grey.100', textAlign: 'center' }}>
      <Box sx={{ py: 1.5, display: 'inline-block' }}>
        <Skeleton variant="rectangular" width={150} height={24} />
      </Box>
    </Box>
  );
};
